import React, { PureComponent } from "react";
import _ from "lodash";
import { connect } from "react-redux";
import { ContentOwnersStyle } from "../styles/ContentOwnersStyle";
import PerfectScrollbar from "react-perfect-scrollbar";
import {
  Table,
  TableBody,
  TableCell,
  TableRow,
  Typography,
  WithStyles,
  withStyles,
  Button,
  TableHead,
  Grid,
  Link,
} from "@material-ui/core";
import {
  MyPATDialog,
  MyPATSelect,
  MyPATTextArea,
  MyPATTextField,
} from "../../common";
import { extractContent, onlyAllowNumbers } from "../../../utils";
import { ContentSubType } from "../../test-template/types/ContentSubTypeBody";
import InputViaDialog from "../common/InputViaDialog";
import AddConceptOrChapter from "../../mylibrary/components/ContentCreate/AddConceptOrChapter";
import CustomInfoIcon from "../../common/CustomInfoIcon";

import {
  Author,
  AuthorFromAPI,
  Question,
  SubQuestionsPassage,
} from "../types/ContentRequest";
import { QUESTION_TYPES } from "../../../constants/comman";
import SubQuestionsPopup from "./SubQuestionsPopup";
import ContentAuthorsPopup from "./ContentAuthorsPopup";
import ACLService from "../../acl/services/aclService";
import { bindActionCreators } from "redux";
import { setUserByRole } from "../actions/contentRequestActions";

interface Props extends WithStyles<typeof ContentOwnersStyle> {
  transferToParent: (data: any) => void;
  questionSubTypes: ContentSubType[];
  questions: Question[];
  subjectId: string;
  isSectionDisabled?: boolean;
  selectedQuestionCodes: string[];
  userRoleMap: any;
  setUserByRole: Function;
}

interface State {
  rows: Question[];
  showSyllabusPopup: boolean;
  showAddContentAuthorsPopup: boolean;
  activeRowIndexForPopup: number;
  draftSyllabus: {
    subjects: any[];
    secondarySubjects: any[];
  };
  showSubQuestionsCountPopup: boolean;
  subQuestionsData: {
    passage: SubQuestionsPassage[];
    count: string | number;
  };
  lastAuthors: { [key: string]: AuthorFromAPI };
}

class ContentOwnersTable extends PureComponent<Props, State> {
  constructor(props: Props) {
    super(props);
    const rows = !_.isEmpty(props.questions) ? props.questions : [EMPTY_ROW];
    this.state = {
      rows,
      showSyllabusPopup: false,
      showAddContentAuthorsPopup: false,
      activeRowIndexForPopup: -1,
      draftSyllabus: EMPTY_DRAFT_SYLLABUS,
      showSubQuestionsCountPopup: false,
      subQuestionsData: { passage: [], count: 0 },
      lastAuthors: {}
    };
    this.handleChange = _.debounce(this.handleChange, 200);
  }

  handleChange = () => {
    this.props.transferToParent({
      questions: this.state.rows,
      subjectId: this.props.subjectId,
    });
  };

  showSubQuestionsCountPopup = () => {
    this.setState((prevState) => {
      const showSubQuestionsCountPopup = !prevState.showSubQuestionsCountPopup;
      let subQuestionsData = prevState.subQuestionsData;
      if (showSubQuestionsCountPopup) {
        const row = prevState.rows[prevState.activeRowIndexForPopup];
        subQuestionsData = {
          passage: row.passage,
          count: row.count || 1,
        };
      }
      return {
        ...prevState,
        showSubQuestionsCountPopup,
        subQuestionsData,
      };
    });
  };

  handleShowSyllabusPopup = (rowIndex: number) => () => {
    this.setState((prevState) => {
      const newDraftSyllabus = JSON.parse(
        JSON.stringify(prevState.rows[rowIndex].syllabus)
      );

      return {
        ...prevState,
        draftSyllabus: newDraftSyllabus,
        showSyllabusPopup: true,
        activeRowIndexForPopup: rowIndex,
      };
    });
  };

  handleShowContentOwnersPopup = (rowIndex: number) => () => {
    this.setState({
      activeRowIndexForPopup: rowIndex,
      showAddContentAuthorsPopup: true,
    });
  };

  handleClosePopup = () => {
    this.setState({
      showAddContentAuthorsPopup: false,
      showSyllabusPopup: false,
      activeRowIndexForPopup: -1,
      draftSyllabus: EMPTY_DRAFT_SYLLABUS,
      showSubQuestionsCountPopup: false,
    });
  };

  componentDidUpdate(prevProps: Props, prevState: State) {
    if (prevState.rows !== this.state.rows) {
      this.handleChange();
    }
    const { selectedQuestionCodes, questionSubTypes } = this.props;
    if (
      prevProps.selectedQuestionCodes !== selectedQuestionCodes &&
      questionSubTypes &&
      questionSubTypes.length > 0
    ) {
      // Set rows based on question code selected
      const newRows = selectedQuestionCodes.reduce(
        (acc: Question[], quesCode) => {
          const subType = questionSubTypes.find(
            ({ code }) => code.toString() === quesCode.toString()
          );
          if (subType) {
            acc.push(
              createEmptyRowByQuestionCode(
                subType.code.toString(),
                subType.name
              )
            );
          }
          return acc;
        },
        []
      );
      this.setState({ rows: newRows });
    }
  }
  updateUserRoleMap = (authors: Author[]) => {
    const { userRoleMap } = { ...this.props };
    const newUserByRole = { ...userRoleMap };
    authors.forEach((author) => {
      if (newUserByRole.hasOwnProperty(author.id)) {
        if (newUserByRole[author.id].count === 1) {
          delete newUserByRole[author.id];
        } else {
          newUserByRole[author.id] = {
            ...newUserByRole[author.id],
            count: newUserByRole[author.id].count - 1,
          };
        }
      }
    });
    this.props.setUserByRole(newUserByRole);
  };
  handleRows = (action: "add" | "remove", index?: number) => {
    this.setState((prevState) => {
      let newRows = [...prevState.rows];

      if (action === "add") {
        const validQuestionSubTypes = this.getValidQuestionSubTypes();
        const subType = validQuestionSubTypes[0] || {
          code: QUESTION_TYPES.SMCQ,
          name: "SMCQ",
        };
        newRows.push(
          createEmptyRowByQuestionCode(subType.code.toString(), subType.name)
        );
      } else if (action === "remove" && !_.isUndefined(index)) {
        console.log(newRows[index]);
        if (newRows[index].authors && newRows[index].authors.length > 0) {
          this.updateUserRoleMap(newRows[index].authors);
        }
        newRows.splice(index, 1);
      }
      return {
        ...prevState,
        rows: newRows,
      };
    });
  };

  setFieldValue = (rowIndex: number) => (event: any) => {
    const { value, name } = event.target;
    const { questionSubTypes } = this.props;

    const { rows } = this.state;

    // If count of a paragrapg question is changed then open subQuestions popup
    if (
      name === "count" &&
      rows[rowIndex].code.toString() === QUESTION_TYPES.PARAGRAPH.toString()
    ) {
      this.setState(
        {
          activeRowIndexForPopup: rowIndex,
        },
        () => this.showSubQuestionsCountPopup()
      );

      return;
    }

    this.setState((prevState) => {
      const newRows = [...prevState.rows];

      const newRow = { ...newRows[rowIndex] };
      // @ts-ignore
      newRow[name] = value;

      if (name === "code") {
        const subType = questionSubTypes.find(({ code }) => code === value);
        if (subType) {
          newRow.type = subType.name;
        }
        // Empty passage data always when code changes
        newRow.passage = [];
      }
      newRows[rowIndex] = newRow;
      return {
        ...prevState,
        rows: newRows,
      };
    });
  };

  onSubjectDraftComplete = () => {
    this.setState(
      (prevState) => {
        const newRows = [...prevState.rows];
        const { activeRowIndexForPopup, draftSyllabus } = prevState;
        const newRow = { ...newRows[activeRowIndexForPopup] };
        newRow.syllabus = draftSyllabus;
        newRows[activeRowIndexForPopup] = newRow;
        return {
          ...prevState,
          rows: newRows,
          draftSyllabus: EMPTY_DRAFT_SYLLABUS,
        };
      },
      () => this.handleClosePopup()
    );
  };

  handleSubjects = (type: "subjects" | "secondarySubjects") => (data: any) => {
    this.setState((prevState) => {
      const newDraftSyllabus = { ...prevState.draftSyllabus };

      newDraftSyllabus[type] = data;
      return {
        ...prevState,
        draftSyllabus: newDraftSyllabus,
      };
    });
  };

  handleSubQuestionsChange = (subQuestionsData: any) => {
    this.setState(
      (prevState) => {
        const { rows, activeRowIndexForPopup } = prevState;
        const newRows = [...rows];

        const newRow = { ...newRows[activeRowIndexForPopup] };
        newRow.count = subQuestionsData.count || 1;
        newRow.passage = subQuestionsData.passage.map((passageItem: any) => {
          passageItem.count = passageItem.count || 2;
          return passageItem
        });
        newRows[activeRowIndexForPopup] = newRow;

        return {
          ...prevState,
          rows: newRows,
        };
      },
      () => this.handleClosePopup()
    );
  };
  handleContentAuthors = (data: { [key: string]: AuthorFromAPI }) => {
    let user = ACLService.getUserDetailsFromStorage();
    user = user && user.authenticatedUser;
 
    this.setState(
      (prevState) => {
        const { rows, activeRowIndexForPopup } = prevState;

        const newRows = [...rows];
        const newRow = { ...newRows[activeRowIndexForPopup] };
        const loggedInClient={ name: user.clientId.name, id: user.clientId._id };

        const newAuthors: Author[] = Object.entries(data).map(
          ([authorType, author]) => {
            const client=_.get(author,"client",loggedInClient);
            return {
              ...author,
              type: authorType,
              client: client,
              assignedDate: new Date().toISOString(),
            };
          }
        );
        
        // sort by order
        newAuthors.sort((a,b) => AUTHOR_ORDER_MAPPING[a.type] - AUTHOR_ORDER_MAPPING[b.type]);

        newRow.authors = newAuthors;
        newRows[activeRowIndexForPopup] = newRow;
        
        return {
          ...prevState,
          rows: newRows,
          lastAuthors: !_.isEmpty(data) ? data : prevState.lastAuthors
        };
      },
      () => this.handleClosePopup()
    );
  };

  getSyllabusRenderValue = (rowIndex: number) => {
    const {
      syllabus: { subjects },
    } = this.state.rows[rowIndex];
    const data = subjects.reduce((acc: string[], subject) => {
      const { checked: subjectCheck, subSubjects, subjectId } = subject;
      if (!subjectId) {
        return acc;
      }
      if (subjectCheck || subjectId.checked) {
        acc.push(subjectId.name);
        return acc;
      }

      for (let subSubject of subSubjects) {
        const { checked: subSubjectCheck, chapters, subSubjectId } = subSubject;
        if (!subSubjectId) {
          continue;
        }
        if (subSubjectId.checked || subSubjectCheck) {
          acc.push(subSubjectId.name);
          continue;
        }
        for (let chapter of chapters) {
          const { checked: chapterCheck, concepts, chapterId } = chapter;
          if (!chapterId) {
            return "";
          }

          if (chapterId.checked || chapterCheck) {
            acc.push(chapterId.name);
            continue;
          }
          for (let concept of concepts) {
            const { checked: conceptCheck, conceptId } = concept;

            if (!conceptId) {
              return "";
            }
            if (conceptId.checked || conceptCheck) {
              acc.push(conceptId.name);
              continue;
            }
          }
        }
      }

      return acc;
    }, []);
    return data.join(", ");
  };

  getAuthorsRenderValue = (rowIndex: number) => {
    const { rows } = this.state;
    const row = rows[rowIndex];
    const { authors } = row;
    return authors.map(({ type, name, client }) => {
      if(!name.includes(client.name)) {
        name =  `${name} | ${client.name}`
      }
      return {
        type: _.capitalize(type === "languageEvaluator" ? "L.Evaluator" : type),
        name: name,
      };
    });
  };
  renderAuthors = (values: any) => {
    const { classes } = this.props;
    return values.map((value: any) => {
      return (
        <div>
          <span className={classes.fontBold}>{_.capitalize(value.type)} :</span>
          <span className={classes.grayFont} style={{display: 'block'}}>
            {value.name.length > 0 ? value.name : "N/A"}
          </span>
        </div>
      );
    });
  };

  getValidQuestionSubTypes = () => {
    const { questionSubTypes, selectedQuestionCodes } = this.props;

    // Only show those question subtypes which are selected from Question Details section

    // These operations need memoization, TODO: Introduce memoization using memoize-one

    let questionSubTypesToShow = questionSubTypes;
    if (selectedQuestionCodes && selectedQuestionCodes.length > 0) {
      questionSubTypesToShow = questionSubTypes.filter((subType) =>
        selectedQuestionCodes.includes(subType.code.toString())
      );
    }
    return questionSubTypesToShow;
  };

  render() {
    const { classes, isSectionDisabled } = this.props;
    const {
      rows,
      showSyllabusPopup,
      draftSyllabus,
      showSubQuestionsCountPopup,
      showAddContentAuthorsPopup,
      subQuestionsData,
      activeRowIndexForPopup,
    } = this.state;

    const questionSubTypesToShow = this.getValidQuestionSubTypes();

    return (
      <>
        <Table className={classes.contentTable}>
          <TableHead>
            <TableRow className={classes.OwnerTable}>
              <TableCell>
                <strong>S.No.</strong>
              </TableCell>
              <TableCell>
                <strong>Question Type</strong>
              </TableCell>
              <TableCell>
                <strong>Count</strong>
              </TableCell>
              <TableCell>
                <strong>
                  Add syllabus for the content                
                <CustomInfoIcon
                  infoDialogContentType="Add syllabus for the content"
                  isCenterArrow={true}
                  isRightArrow={false}
                  isInfoIcon={true}
                  knowMoreAbout={false}
                  dialogTitle="Add syllabus for the content"
                  imageURL="/assets/svg/contentRequest/syllabusIcon.svg"
                  dialogPara="In this column you have to tag relevant syllabus of the content as per the requirement."
                  details="Click to know more"
                  toolTipDirection="top"
                />
                </strong>
              </TableCell>
              <TableCell>
                <strong>
                  Specify Content Authors
                  <CustomInfoIcon
                    infoDialogContentType="Select Content Owners"
                    isInfoIcon={true}
                    isRightArrow={false}
                    isCenterArrow={true}
                    knowMoreAbout={false}
                    dialogTitle="Select Content Authors"
                    imageURL="/assets/svg/contentRequest/contentOwner.svg"
                    dialogPara=""
                    details="Click to know more"
                    toolTipDirection="top"
                    htmlElement={
                      <>
                        <Grid
                          container
                          justify="center"
                          className={classes.mtb30}
                        >
                          <Typography className={classes.font16}>
                            In this column,you can assign role category to
                            authors in your organization. There are five
                            categories and the workflow follow as per the order
                            below:
                          </Typography>
                          <Typography className={classes.font16}>
                            Creator, Evaluator, Language Evaluator, Moderator,
                            Publisher
                          </Typography>
                          <Typography className={classes.font16}>
                            An author can be mapped with one role category in a
                            request. You need to click + icon to add authors in
                            this table
                          </Typography>
                        </Grid>
                      </>
                    }
                  />
                </strong>
              </TableCell>
              <TableCell>
                <strong>Additional Description</strong>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row, i) => {
              const { count } = row;
              const isFirstRow = i === 0;

              return (
                <TableRow key={i}>
                  <TableCell>{i + 1}</TableCell>
                  <TableCell>
                    <MyPATSelect
                      fullWidthControl
                      required
                      onChange={this.setFieldValue(i)}
                      label=""
                      inputId="code"
                      name="code"
                      value={row.code}
                      disabled={isSectionDisabled}
                    >
                      {questionSubTypesToShow.map((questionType, index) => {
                        return (
                          <option
                            key={`${questionType._id} ${index}`}
                            value={questionType.code}
                          >
                            {questionType.name}
                          </option>
                        );
                      })}
                    </MyPATSelect>
                  </TableCell>
                  <TableCell>
                    <div className={classes.posRelative} style={{width: '50px'}}>
                      <MyPATTextField
                        fullWidthControl
                        inputId="count"
                        name="count"
                        value={count}
                        placeholder="Ex. 1"
                        type="number"
                        onChange={this.setFieldValue(i)}
                        onKeyPress={onlyAllowNumbers}
                        inputProps={{ min: 1 }}
                        disabled={isSectionDisabled}
                      />
                    </div>
                  </TableCell>
                  <TableCell
                    style={
                      this.getSyllabusRenderValue(i).length === 0
                        ? { height: "36px" }
                        : { height: "95px" }
                    }
                  >
                    <div
                      className={classes.manageLineHeight}
                      style={
                        this.getSyllabusRenderValue(i).length === 0
                          ? { height: "42px" }
                          : { height: "95px" }
                      }
                    >
                      <PerfectScrollbar>
                        <InputViaDialog
                          value={this.getSyllabusRenderValue(i)}
                          placeholder="Add Tags for the questions"
                          handleAddOrEdit={this.handleShowSyllabusPopup(i)}
                          disabled={isSectionDisabled}
                        />
                      </PerfectScrollbar>
                    </div>
                  </TableCell>
                  <TableCell
                    style={
                      this.getAuthorsRenderValue(i).length === 0
                        ? { height: "36px" }
                        : { height: "95px" }
                    }
                  >
                    <div
                      style={
                        this.getAuthorsRenderValue(i).length === 0
                          ? { height: "42px" }
                          : { height: "95px" }
                      }
                    >
                      <PerfectScrollbar>
                        <InputViaDialog
                          value={this.getAuthorsRenderValue(i)}
                          placeholder="Add Content Owners"
                          handleAddOrEdit={this.handleShowContentOwnersPopup(i)}
                          renderer={this.renderAuthors.bind(this)}
                          disabled={isSectionDisabled}
                        />
                      </PerfectScrollbar>
                    </div>
                  </TableCell>
                  <TableCell>
                    {/* <span className={classes.borderShow}> */}
                    <MyPATTextArea
                      inputId="description"
                      name="description"
                      onChange={this.setFieldValue(i)}
                      value={extractContent(row.description)}
                      multiline
                      fullWidthControl
                      placeholder="Add extra requirements"
                      disabled={isSectionDisabled}
                    />
                    {/* </span> */}
                  </TableCell>
                  {!isFirstRow && (
                    <div onClick={() => this.handleRows("remove", i)}>
                      <span className={classes.addPointer}>
                        <img src="/assets/svg/delete.svg" alt="remove" />
                      </span>
                      {/* <Button
                        onClick={() => this.handleRows("remove", i)}
                        variant="contained"
                        color="secondary"
                      >
                        Delete
                      </Button> */}
                    </div>
                  )}
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
        <Typography
          className={classes.AddMore}
          onClick={() => !isSectionDisabled && this.handleRows("add")}
        >
          Add more
          <img src="/assets/svg/contentRequest/primaryPlus.svg" alt="Add" />
        </Typography>
        {showSyllabusPopup && (
          <MyPATDialog
            dialogOpen={true}
            dialogHasActions={true}
            dialogHeading={
              <>
                <span>
                  Add Concept or Chapter
                  {/* <sup>*</sup> */}
                </span>
              </>
            }
            // customButtonVariant="withoutBorderCloseIcon"
            onDialogClose={this.handleClosePopup}
            isCustomBackground={false}
            isborderDialogAction={false}
            otherDialogProps={{
              fullWidth: false,
              maxWidth: "md",
            }}
            customDialogActions={
              <>
                <Grid
                  container
                  justify="flex-end"
                  alignItems="center"
                  // className={classes.dialogActions}
                >
                  <Grid item>
                    <Button
                      color="primary"
                      onClick={() => {
                        this.handleSubjects("subjects")([]);
                        this.handleSubjects("secondarySubjects")([]);
                      }}
                    >
                      Reset
                    </Button>
                  </Grid>
                  <Grid item>
                    <Button
                      // onClick={this.handleDialogClose.bind(this)}
                      // disabled={isDisableRepublishAll}
                      // className={classes.okButton}
                      variant="contained"
                      color="primary"
                      onClick={this.onSubjectDraftComplete}
                    >
                      Done
                    </Button>
                  </Grid>
                </Grid>
              </>
            }
          >
            <AddConceptOrChapter
              defaultExpanded={false}
              formData={draftSyllabus.subjects}
              handleFormChange={this.handleSubjects("subjects")}
              showWithoutExpansionPanel
            />
          </MyPATDialog>
        )}
        {showSubQuestionsCountPopup && (
          <SubQuestionsPopup
            onDone={this.handleSubQuestionsChange}
            onClose={this.handleClosePopup}
            subQuestionsData={subQuestionsData}
          />
        )}
        {showAddContentAuthorsPopup && (
          <ContentAuthorsPopup
            onClose={this.handleClosePopup}
            onDone={this.handleContentAuthors}
            authors={rows[activeRowIndexForPopup].authors}
            otherQuestionData={rows}
            currentAuthorData={rows[activeRowIndexForPopup]._id}
            lastAuthors={this.state.lastAuthors}
          />
        )}
      </>
    );
  }
}

const EMPTY_DRAFT_SYLLABUS = {
  secondarySubjects: [],
  subjects: [],
};

const EMPTY_ROW = {
  authors: [],
  syllabus: EMPTY_DRAFT_SYLLABUS,
  count: "",
  contentRequestItemsId: null,
  passage: [],
  description: "",
  endDate: "",
  startDate: "",
  code: "0",
  type: "SMCQ",
};

const AUTHOR_ORDER_MAPPING: { [key: string]: number } = {
  'creator': 0,
  'evaluator': 1,
  'languageEvaluator': 2,
  'moderator': 3,
  'publisher': 4
}

const createEmptyRowByQuestionCode = (code: string, type: string) => {
  return {
    ...EMPTY_ROW,
    code,
    type,
  };
};

const mapStateToProps = (state: any) => {
  return {
    selectedQuestionCodes:
      state.contentRequestReducer.contentRequestCreateReducer
        .selectedQuestionCodes,
    userRoleMap:
      state.contentRequestReducer.contentRequestCreateReducer.userRoleMap,
  };
};
const mapDispatchToProps = (dispatch: any) =>
  bindActionCreators(
    {
      setUserByRole,
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
  // @ts-ignore
)(withStyles(ContentOwnersStyle)(ContentOwnersTable));
